import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Box, Modal, Tooltip } from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
// import io from "socket.io-client";
import Alert from "../../components/Alert/Alert";
import { StartSessionCountdownTimer } from "../../components/Timer/StartSessionTimer";
import VideoPlayer from "../../components/VideoPlayer/VideoPlayer";
// import { CountdownTimer } from "../../components/Timer/Timer";
import { Color } from "../../../GlobalStyles";
import { SlotsContext } from "../../AppContext";
import PdfViewer from "../DocumentsAndFeedback/PdfViewer";
// import SessionNotStarted from "../Students/SessionNotStarted/SessionNotStarted";
import {
  checkDate,
  formatConvertermonthfirst,
} from "../../services/dateFunctions";
import TimeService from "../../services/epochTime";
import Service from "../../services/httpService";
import {
  calculateEpochTimeInLocalTime,
  extractDateFromDateString,
} from "../../services/specialCharReplace";
import "../Mentors/UpcomingBooking/UpcomingBooking.css";
const UpcomingBookingCard = props => {
  const time = new TimeService();
  const services = new Service();
  //location data
  const { slot, user_type } = props;
  // console.log("slotdata", slot);
  console.log("slot", user_type.includes("student"), user_type, slot);
  // constants
  const { slotsContextData, setSlotsContextData } = useContext(SlotsContext);
  console.log("slotsContextData", slotsContextData);
  // console.log("slotsContextData", slotsContextData);
  const navigate = useNavigate();
  const [session_guidelines, setSessionGuidelines] = useState({});
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState(false);
  const [popup, setPopup] = useState(() => {
    return !sessionStorage.getItem("jobPopup"); // Show only if not previously shown
  });
  const [openPdfModal, setOpenPdfModal] = useState(false);
  const [loading, setLoading] = useState({
    resume: false,
    cart: false,
    jobs: false,
  });
  //socket
  // const socket = io("localhost:3001");
  // const socketRef = useRef();
  // const socket = io("https://socket.careercarve.in/");
  const [is_time_ended, set_is_time_ended] = useState(false);
  //variables
  const [conditionals, setConditionals] = useState({
    join_session: true,
    start_session: false,
  });

  //flags json
  const [flag, setFlag] = useState({ time_over: false });
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  // const [buttonDisabled, setButtonDisabled] = useState(true);

  // bhoomika
  // const [sessionStarted, setSessionStarted] = useState(false);
  // console.log("SLOT", slot);
  // const handleStartSession = () => {
  //   setSessionStarted(true);
  // };

  // const handleTimerFinish = () => {
  //   console.log("Timer finished");
  //   setSessionStarted(false);
  // };
  // define default props

  //enable start session
  useEffect(() => {
    if (!slot) return;

    const fetchSlot = async () => {
      try {
        const res = await services.get(`/superadmin/order?order_id=${slot.id}`);
        setSessionGuidelines(res.session_guidelines);
      } catch (error) {
        console.error(error?.response?.data?.message || error.message);
      }
    };

    fetchSlot();
  }, [slot]);

  console.log("session_guidelines", session_guidelines);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const currentDate = new Date().getTime();
      // console.log(
      //   `present date: ${timeService.getUTCPresentDateAndTimeInMS()}, currentDate: ${currentDate}`
      // );

      const currentTimeMS = currentDate;
      set_is_time_ended(currentDate > slot.end_time);

      //15 min before time but should end on time
      if (user_type !== "mentor") {
        if (slot.order_flag === "In process" && slot.mentor_joined === 1)
          setConditionals({ ...conditionals, join_session: true });
        else if (
          slot.student_feedback_submitted === 1 &&
          (slot.order_flag === "Feedback" || slot.order_flag === "Done")
        ) {
          setConditionals({ ...conditionals, join_session: true });
        }
      }
      if (slot.order_flag === "Scheduled") {
        const remainingTimeMS = slot.start_time - currentTimeMS;
        setRemainingSeconds(Math.ceil(remainingTimeMS / 1000));
        if (currentTimeMS >= slot.end_time + 900000) {
          setFlag(prev => ({ ...prev, time_over: true }));
        }
        if (
          currentTimeMS >= slot.start_time &&
          currentTimeMS <= slot.end_time + 900000
        ) {
          setConditionals(prevState => ({
            ...prevState,
            start_session: true,
          }));
          clearInterval(intervalId);
        } //to be enabled to set timer value
        else
          setConditionals(prevState => ({
            ...prevState,
            start_session: false,
          }));
      } else {
        setConditionals(prevState => ({
          ...prevState,
          start_session: true,
        })); //to be enabled to set timer value
      }

      if (props.settingType === "upcoming") {
        props.setIsLoadingUpcoming(false);
      } else {
        props.setIsLoadingRecent(false);
      }
    }, 1000); // check every second

    return () => clearInterval(intervalId); // clean up on unmount
  }, []); // run only once on mount

  const handleStartSession = async () => {
    //backend call
    window.sessionStorage.setItem("slot", JSON.stringify(slot));
    navigate(`/preview/${slot.room_id}/mentor`);
  };
  const handleMarkAbsent = async () => {
    let body = {
      order_id: slot.id,
      is_absent: 1,
    };
    try {
      await services.put(`/scheduling/session/endSession`, body);
      navigate(`/`);
    } catch (err) {
      console.log(err.message || err.response.data.message);
    }
  };

  const responseAlert = data => {
    // bhoomika changes
    if (data === "Yes")
      slot.mentor_joined === 1 &&
      (slot.order_flag === "In process" ||
        slot.order_flag === "Feedback" ||
        slot.order_flag === "Done") && //----------------------------->> when its "Comments" and not the other Tabs
      // is_time_ended &&
      user_type === "mentor"
        ? handleMarkAbsent()
        : handleStartSession();
    else setAlert(false);
  };

  const handleSessionClick = async () => {
    console.log("in handleSessionClick", ["student"].includes(user_type));
    if (slot.mentor_joined !== 1) {
      window.sessionStorage.setItem(
        "joiningTime",
        time.getUTCPresentTimeInMS()
      );
    }

    window.sessionStorage.setItem("slot", JSON.stringify(slot));

    if (user_type === "mentor") {
      setSlotsContextData(slot);
      if (slot.mentor_joined === 0) {
        setAlertMessage(
          "Once you start the session, a notification will be sent to the student to join the session immediately. Kindly take this action as close as possible to the scheduled time. Do you want to start the activity?"
        );
        setAlert(true);
      } else {
        navigate(`/preview/${slot.room_id}/mentor`);
      }
    } else if (user_type.includes("student")) {
      const { data } = await services.get(
        `/superadmin/order?order_id=${slot.id}`
      );
      if (data[0].mentor_joined === 0) {
        navigate("/SessionNotStarted");
      } else if (data[0].mentor_joined === 1) {
        window.sessionStorage.setItem(
          "mentor_join_time",
          data[0].mentor_join_time
        );
        setSlotsContextData(data[0]);
        navigate(`/preview/${slot.room_id}/student`);
      }
    }
  };

  const handleFeedbackOverview = slot => {
    window.sessionStorage.setItem("slot", JSON.stringify(slot));
    setSlotsContextData(slot);
    navigate(`/FeedbackOverview?order_id:${slot.id}`, { state: slot });
  };

  const handleFeedbackReview = slot => {
    setSlotsContextData(slot);
    navigate(`/FeedbackReview?order_id=${slot.id}`, { state: slot });
  };
  const handleFeedbackFromStudent = slot => {
    window.sessionStorage.setItem("slot", JSON.stringify(slot));
    setSlotsContextData(slot);
    navigate(`/FeedbackFromStudent`, { state: slot });
  };

  const handleAlert = is_alert => {
    if (is_alert === true) {
      setAlertMessage("Mark this student as Absent?");
      setAlert(true);
    }
  };

  const handleCountDownFinish = () => {
    setConditionals(prevState => ({
      ...prevState,
      start_session: true,
    }));
  };

  const base64UrlEncode = str => {
    const bytes = new TextEncoder().encode(str);
    let binary = "";
    for (let i = 0; i < bytes.length; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary)
      .replace(/=/g, "")
      .replace(/\+/g, "-")
      .replace(/\//g, "_");
  };

  const handleResumeDigital = () => {
    setLoading(prev => ({ ...prev, resume: true }));
    // console.log("window parent", window.parent.location);
    // window.parent.location.href = `${window.parent.location.origin}/Dashboard/temp-0001`;
    window.parent.postMessage(
      { type: "NAVIGATE", path: "/Dashboard/temp-0001" },
      process.env.REACT_FRONTEND_URL // parent origin
    );
  };
  const handleRealityCheck = () => {
    setLoading(prev => ({ ...prev, cart: true }));
    const params = new URLSearchParams({
      basket: JSON.stringify([
        {
          id: process.env.REACT_APP_ENV === "prod" ? 2 : 16,
          search_tbl: "sku",
          quantity: 1,
        },
      ]),
      mentor_id: slot.mentor_id.toString() || "",
      mentor_name: slot.mentor_name || "",
      priority_number: "1",
    });
    const encodedId = base64UrlEncode(params.toString());
    // console.log("encodedId", encodedId);
    window.parent.postMessage(
      {
        type: "NAVIGATE",
        path: `/mentor-connect/CartScreen?cart=${encodedId}`,
      },
      process.env.REACT_FRONTEND_URL // parent origin
    );
  };

  const handlePopupClose = () => {
    setPopup(false);
    sessionStorage.setItem("jobPopup", "false");
  };

  const handleJobExplore = () => {
    setLoading(prev => ({ ...prev, jobs: true }));
    sessionStorage.setItem("jobPopup", "false");
    window.parent.postMessage(
      { type: "NAVIGATE", path: "/Dashboard/Companies" },
      process.env.REACT_FRONTEND_URL // parent origin
    );
    setPopup(false);
  };
  return (
    <div
      className="upcoming"
      style={{
        marginBottom: "40px",
      }}
    >
      {/* <p>remainingMinutes: {remainingMinutes}</p> */}
      <Card
        sx={{
          minWidth: 275,
          background:
            flag.time_over ||
            slot.is_absent === 1 ||
            slot.order_flag === "On hold" ||
            slot.order_flag === "Missed"
              ? Color.neutralLightGrey
              : Color.white,
          border: "1px solid #E6E6E6",
          boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.08)",
          borderRadius: "40px",
        }}
      >
        <CardContent>
          <div className="upcomingBookingContent">
            <div className="upcomingBookingDescription">
              <Typography variant="h5">{slot.sku_name}</Typography>
              <Typography
                sx={{ fontSize: 18, marginTop: "1%", mb: 0 }}
                color="#000000"
                gutterBottom
              >
                {/* {console.log({ start: conditionals.start_session })} */}
                {formatConvertermonthfirst(
                  extractDateFromDateString(slot.start_time)
                )}
                {!["invalid", "day before yesterday"].includes(
                  checkDate(extractDateFromDateString(slot.start_time))
                ) ? (
                  " (" +
                  (checkDate(extractDateFromDateString(slot.start_time)) ===
                  "today"
                    ? "Today"
                    : checkDate(extractDateFromDateString(slot.start_time)) ===
                      "tomorrow"
                    ? "Tomorrow"
                    : checkDate(extractDateFromDateString(slot.start_time)) ===
                      "yesterday"
                    ? "Yesterday"
                    : "") +
                  ")"
                ) : (
                  <></>
                )}
                , {calculateEpochTimeInLocalTime(slot.start_time)} -{" "}
                {calculateEpochTimeInLocalTime(slot.end_time)}
              </Typography>
              <Typography sx={{ mb: 2, mt: 0 }} color="color: #000000;">
                with{" "}
                {user_type === "mentor" ? slot?.user_name : slot?.mentor_name}
              </Typography>
              {user_type !== "mentor" && slot.order_flag === "Scheduled" ? (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ color: Color.green }}
                >
                  CONFIRMED
                </Typography>
              ) : slot.mentor_joined === 1 &&
                slot.order_flag === "In process" &&
                is_time_ended &&
                user_type === "mentor" ? (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ color: Color.green }}
                >
                  ONGOING
                </Typography>
              ) : null}
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mb: user_type !== "mentor" ? 1 : 2 }}
              >
                {slot.duration} for {slot.role_name} <br />
                in {slot.specialization_name}
                <br />
              </Typography>
              {/* {console.log({ joins_session: conditionals.join_session })} */}
              <div style={{ display: "flex", alignItems: "center" }}>
                {/* slot.order_flag === "Done" &&
                  slot.student_feedback_submitted === 1  */}
                {slot.order_flag === "Missed" ? (
                  <Typography variant="body2" color={Color.red} sx={{ mb: 2 }}>
                    {user_type === "mentor"
                      ? "You were absent for this session"
                      : "Mentor missed the session"}
                    <br />
                  </Typography>
                ) : slot.order_flag === "On hold" ? (
                  <Typography variant="body2" color={Color.red} sx={{ mb: 2 }}>
                    {user_type === "mentor" ? "On Hold" : "On Hold"}
                    <br />
                  </Typography>
                ) : slot.is_absent === 1 ? (
                  user_type === "mentor" ? (
                    <Typography
                      variant="body2"
                      color={Color.red}
                      sx={{ mb: 2 }}
                    >
                      Student has been marked absent
                      <br />
                    </Typography>
                  ) : (
                    <Typography
                      variant="body2"
                      color={Color.red}
                      sx={{ mb: 2 }}
                    >
                      Student has been marked absent
                      <br />
                    </Typography>
                  )
                ) : (
                  <>
                    {slot.order_flag === "Feedback" &&
                    slot.student_join_time === null &&
                    slot.is_absent === 0 ? (
                      <></>
                    ) : (
                      <>
                        <button
                          sx={{ alignContent: "flex-end" }}
                          disabled={
                            user_type !== "mentor"
                              ? conditionals.join_session === false
                                ? true
                                : false
                              : conditionals.start_session === false
                              ? true
                              : false
                          }
                          className={
                            slot.order_flag === "Feedback" ||
                            slot.order_flag === "Done"
                              ? "StartSEssionbutton-outline"
                              : "StartSEssionbutton"
                          }
                          size="small"
                          style={{
                            width:
                              user_type === "mentor" &&
                              ((slot.order_flag === "Feedback" &&
                                slot.mentor_feedback_submitted === 0) ||
                                (slot.order_flag === "Done" &&
                                  slot.mentor_feedback_submitted === 0))
                                ? "40%"
                                : "80%",
                            marginTop:
                              user_type !== "mentor"
                                ? "0px"
                                : user_type === "mentor" &&
                                  ((slot.order_flag === "Feedback" &&
                                    slot.mentor_feedback_submitted === 0) ||
                                    (slot.order_flag === "Done" &&
                                      slot.mentor_feedback_submitted === 0))
                                ? "-3px"
                                : slot.order_flag === "Scheduled" ||
                                  slot.order_flag === "In process"
                                ? "0px"
                                : "16px",
                          }}
                          onClick={
                            () =>
                              user_type === "mentor"
                                ? slot.order_flag === "Scheduled"
                                  ? handleSessionClick() //start session
                                  : slot.order_flag === "In process"
                                  ? handleSessionClick() //join session
                                  : slot.order_flag === "Feedback"
                                  ? slot.mentor_feedback_submitted === 1
                                    ? handleFeedbackOverview(slot)
                                    : handleFeedbackOverview(slot) //provide feedback
                                  : slot.order_flag === "Done"
                                  ? slot.mentor_feedback_submitted === 0
                                    ? handleFeedbackReview(slot)
                                    : handleFeedbackReview(slot) //View details
                                  : ""
                                : //student condition
                                slot.order_flag === "Feedback" ||
                                  slot.order_flag === "Done" //after student has submitted notes
                                ? slot.student_feedback_submitted === 1
                                  ? "" //Feedback Given
                                  : handleFeedbackFromStudent(slot) // "Give Feedback"
                                : handleSessionClick() // "Join Session"
                          }
                        >
                          {}
                          {
                            user_type === "mentor" ? (
                              slot.order_flag === "Scheduled" &&
                              remainingSeconds > 0 &&
                              remainingSeconds <= 900 ? (
                                <StartSessionCountdownTimer
                                  onFinish={() => handleCountDownFinish()}
                                  second={remainingSeconds}
                                />
                              ) : slot.order_flag === "Scheduled" ? (
                                "Start Session"
                              ) : slot.order_flag === "Scheduled" &&
                                remainingSeconds < 0 ? (
                                "Start Session"
                              ) : slot.order_flag === "In process" ? (
                                "Join Session"
                              ) : slot.order_flag === "Feedback" ? (
                                slot.mentor_feedback_submitted === 1 ? (
                                  "View Details"
                                ) : (
                                  "Provide Feedback"
                                )
                              ) : slot.order_flag === "Done" ? (
                                slot.mentor_feedback_submitted === 0 ? (
                                  "Provide Feedback"
                                ) : (
                                  "View Details"
                                )
                              ) : (
                                "Invalid"
                              )
                            ) : //student condition
                            slot.order_flag === "Feedback" ||
                              slot.order_flag === "Done" ? ( //after student has submitted notes
                              slot.student_feedback_submitted === 1 ? (
                                "Feedback Given" //after student has submitted feedback
                              ) : (
                                "Give Feedback"
                              ) // not submitted feedback
                            ) : (
                              "Join Session"
                            ) //not submitted notes
                          }
                        </button>
                      </>
                    )}
                  </>
                )}

                {/* 2nd button */}
                {user_type === "mentor" &&
                slot.order_flag === "Feedback" &&
                slot.student_join_time === null &&
                slot.is_absent !== 1 ? (
                  // ||
                  // (slot.order_flag === "Done" &&
                  //   slot.mentor_feedback_submitted === 0 &&
                  //   slot.is_absent !== 1)
                  <>
                    <button
                      disabled={
                        user_type !== "mentor"
                          ? conditionals.join_session === false
                            ? true
                            : false
                          : conditionals.start_session === false
                          ? true
                          : false
                      }
                      className="StartSEssionbutton-outline"
                      size="small"
                      style={{
                        marginTop:
                          checkDate(
                            extractDateFromDateString(slot.start_time)
                          ) === "today"
                            ? "28.px"
                            : "24px",
                        width: "40%",
                        marginLeft:
                          slot.order_flag === "Feedback" &&
                          slot.student_join_time === null &&
                          slot.is_absent === 0
                            ? "0%"
                            : "5%",
                        marginTop: "-0.2rem",
                      }}
                      onClick={() => {
                        handleAlert(true);
                      }}
                    >
                      Mark Absent
                    </button>
                  </>
                ) : (
                  <></>
                )}
              </div>
              {}
              {user_type === "mentor" && slot.order_flag === "Scheduled" ? (
                <>
                  {!flag.time_over && (
                    <Typography
                      style={{ fontSize: "12px", textAlign: "center" }}
                    >
                      You will be able to start the session at the scheduled
                      time
                    </Typography>
                  )}
                </>
              ) : user_type === "mentor" &&
                slot.order_flag === "Scheduled" &&
                remainingSeconds > 0 &&
                remainingSeconds <= 900 ? (
                <>
                  <Typography style={{ fontSize: "12px", textAlign: "center" }}>
                    15 minutes to start the session
                  </Typography>
                </>
              ) : user_type === "mentor" &&
                slot.order_flag === "Scheduled" &&
                remainingSeconds < 0 ? (
                <>
                  <Typography style={{ fontSize: "12px", textAlign: "center" }}>
                    Once you start the session, the student will receive a
                    notification mentioning that the session has started
                  </Typography>
                </>
              ) : (
                <>
                  <Typography style={{ fontSize: "12px", textAlign: "center" }}>
                    {/* 15 minutes to start the session */}
                  </Typography>
                </>
              )}
              {user_type != "mentor" &&
                (slot.order_flag === "Feedback" ||
                  slot.order_flag === "Done") && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: 1,
                      mt: 1,
                      width: "100%",
                    }}
                  >
                    {slot.act_type_id == 2 && (
                      <Tooltip
                        arrow
                        placement="top"
                        title="Apply your mentor's feedback and lock in a resume that stands out to employers."
                      >
                        <button
                          className="StartSEssionbutton-outline"
                          size="small"
                          style={{ display: "block", width: "40%" }}
                          onClick={handleResumeDigital}
                          disabled={loading.resume}
                        >
                          {loading.resume
                            ? "Loading..."
                            : "Finalize Your Resume"}
                        </button>
                      </Tooltip>
                    )}
                    {slot.end_time + 30 * 24 * 60 * 60 * 1000 <
                      new Date().getTime() && (
                      <Tooltip
                        arrow
                        placement="top"
                        title={`It's been a month since your ${slot.act_type_name} — how are your applications going so far? If you'd like more guidance, book a follow-up with your mentor to discuss queries and get sharper feedback.`}
                      >
                        <button
                          className="StartSEssionbutton-outline"
                          size="small"
                          style={{ display: "block", width: "40%" }}
                          onClick={handleRealityCheck}
                          disabled={loading.cart}
                        >
                          {loading.cart ? "Loading..." : "Get a Reality Check"}
                        </button>
                      </Tooltip>
                    )}
                  </Box>
                )}
            </div>
            <div
              className="upcomingBookingDocuments"
              id="upcomingBookingDocuments"
            >
              <Typography
                className="relatedDocuments"
                id="relatedDocuments"
                sx={{ fontSize: 16 }}
                style={{
                  marginBottom: "1rem",
                  textAlign: "center",
                  fontSize: "16px",
                  fontWeight: 540,
                }}
              >
                Related Documents
              </Typography>
              <div className="iconAndName2">
                <PictureAsPdfIcon
                  style={{ color: "#1c8ea8", marginRight: "5%" }}
                />
                {/* <p
                  style={{ color: "#1c8ea8" }}
                  className="upcomingBookingFileName"
                >
                  {slot.resume.name}
                </p> */}
                <button
                  style={{ color: "#1c8ea8" }}
                  className="upcomingBookingFileName"
                  onClick={() => window.open(slot.resume.url || "")}
                >
                  {/* cell.substring(0, 30).concat(cell.length > 30 ? "..." : "") : cell */}
                  {slot.resume.name
                    .substring(0, 25)
                    .concat(slot.resume.name.length > 25 ? "..." : "") ||
                    "No resume attached"}
                </button>
              </div>
              {slot.file_url ? (
                <div className="iconAndName2">
                  <PictureAsPdfIcon
                    style={{ color: "#1c8ea8", marginRight: "5%" }}
                  />
                  <button
                    style={{ color: "#1c8ea8" }}
                    className="upcomingBookingFileName"
                    onClick={() => window.open(slot.file_url || "")}
                  >
                    {slot.file_url ? (
                      slot.file_url
                        .split("/")
                        .pop()
                        .replace(/^Job\+Description\//, "")
                        .substring(0, 25)
                        .concat(
                          slot.file_url
                            .split("/")
                            .pop()
                            .replace(/^Job\+Description\//, "").length > 25
                            ? "..."
                            : ""
                        )
                    ) : (
                      <></>
                    )}
                  </button>
                </div>
              ) : (
                <></>
              )}

              {slot.other_docs.files.length > 0 ? (
                slot.other_docs.files.map(file => (
                  <div className="iconAndName2">
                    <PictureAsPdfIcon
                      style={{
                        color: "#1c8ea8",
                        float: "left",
                        marginRight: "5%",
                      }}
                    />
                    <button
                      className="feedbackFileName"
                      onClick={() => window.open(file.url)}
                    >
                      <p
                        style={{ color: "#1c8ea8" }}
                        className="upcomingBookingFileName"
                      >
                        {file.name || "No file attached"}
                      </p>
                    </button>
                  </div>
                ))
              ) : (
                <></>
              )}
            </div>
            <div className="upcomingBookingVideo">
              <Typography className="upcomingBookingRecommended">
                {user_type === "mentor" && session_guidelines
                  ? "Session Guidelines"
                  : "Recommended Video"}
              </Typography>

              {user_type === "mentor" ? (
                session_guidelines ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      width: "90%",
                      height: "90%",
                    }}
                  >
                    <Box
                      onClick={() => setOpenPdfModal(true)}
                      sx={{
                        cursor: "pointer",
                        width: "350px",
                        height: "auto",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "11px",
                        overflow: "hidden",
                        "&:hover": {
                          opacity: 0.8,
                        },
                      }}
                    >
                      <PdfViewer
                        url={
                          typeof session_guidelines === "string"
                            ? session_guidelines
                            : session_guidelines?.url
                        }
                      />
                    </Box>

                    <Modal
                      open={openPdfModal}
                      onClose={() => setOpenPdfModal(false)}
                      aria-labelledby="pdf-modal-title"
                      aria-describedby="pdf-modal-description"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: "90%",
                          maxWidth: "1200px",
                          height: "90vh",
                          bgcolor: "background.paper",
                          boxShadow: 24,
                          borderRadius: "10px",
                          outline: "none",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            padding: "1rem 1.5rem",
                            borderBottom: "1px solid #e0e0e0",
                          }}
                        >
                          <button
                            onClick={() => setOpenPdfModal(false)}
                            style={{
                              background: "none",
                              border: "none",
                              fontSize: "2rem",
                              cursor: "pointer",
                              padding: "0",
                              lineHeight: "1",
                              color: "#666",
                            }}
                          >
                            ×
                          </button>
                        </Box>

                        <Box
                          sx={{
                            flex: 1,
                            overflowY: "auto",
                            padding: "1.5rem",
                          }}
                        >
                          <PdfViewer
                            url={
                              typeof session_guidelines === "string"
                                ? session_guidelines
                                : session_guidelines?.url
                            }
                          />
                        </Box>
                      </Box>
                    </Modal>
                  </Box>
                ) : slot.aws !== null ? (
                  <VideoPlayer url={slot.aws_url} />
                ) : (
                  <img
                    src={slot.image_url}
                    alt="Recommended"
                    style={{
                      borderRadius: "11px",
                      height: "auto",
                      width: "350px",
                      objectFit: "cover",
                    }}
                  />
                )
              ) : (
                <div>
                  {slot?.student_material?.video?.path ? (
                    <VideoPlayer url={slot.student_material.video.path} />
                  ) : (
                    <img
                      src={slot.image_url}
                      alt="Recommended"
                      style={{
                        borderRadius: "11px",
                        width: "350px",
                        height: "auto",
                        objectFit: "cover",
                      }}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </CardContent>

        <CardActions />
      </Card>
      <Alert
        heading="Alert"
        body={alertMessage}
        alert={alert}
        setAlert={setAlert}
        responseAlert={responseAlert}
      />
      {user_type.includes("student") && (
        <div
          class="popup-overlay"
          id="popup"
          style={{ display: popup ? "flex" : "none" }}
        >
          <div class="popup-content">
            <button class="popup-close" onClick={handlePopupClose}>
              ×
            </button>
            <div class="popup-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <div class="popup-title">🎉 Looks like you are Job ready!</div>
            <div class="popup-message">
              Let's get you curated jobs to apply for right away.
            </div>
            <button
              class="popup-button"
              onClick={() => handleJobExplore()}
              disabled={loading.jobs}
            >
              {loading.jobs ? "Loading..." : "Explore jobs"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpcomingBookingCard;
